"use client";

import Link from "next/link";
import Image from "next/image";
import HemburgerIcon from "@/utils/svgIcons/HemburgerIcon";
import UserAccountIcon from "@/utils/svgIcons/UserAccountIcon";

const MobileNav = ({ open, setOpen }: { open: boolean; setOpen: any }) => {
  return (
    <nav className="flex lg:hidden items-center justify-between h-full">
      <div className="container h-full flex items-center justify-between">
        <Link
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="flex items-center gap-3.5"
          href="/affiliate"
        >
          <Image
            alt="DALAL Site Logo"
            loading="lazy"
            width={46}
            height={33}
            src="/assets/favicon-image.png"
            style={{ color: "transparent" }}
          />
          <p className="tracking-[10px] text-white uppercase leading-5">
            <strong>DALAL</strong> <br />
            Affiliates
          </p>
        </Link>

        <div className="flex items-center text-[24px] gap-3">
          <Link
            target="_blank"
            rel="noopener noreferrer nofollow"
            href="/affiliate"
          >
            <UserAccountIcon />
          </Link>

          <button onClick={() => setOpen(!open)} className="shrink-0">
            <HemburgerIcon />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default MobileNav;
